import * as React from 'react';
import classnames from 'classnames';

import Tooltip from 'components/Tooltip';
import Popover from 'components/popover/Popover';
import SVGDynamicIcon from 'components/svg-dynamic-icon/SVGDynamicIcon';

import ContentPlaceholderInfo from './info/ContentPlaceholderInfo';

import { __t, applyTranslations } from 'utils/language';

import './consent-placeholder.scss';

applyTranslations(require('./content-placeholder.i18n.json'));

type Props = {
  type: 'instagram' | 'youtube' | 'tiktok',
  link?: string,
  withLearnMore?: boolean,
  withLinkOnTheLeft?: boolean,
  onClick?: () => void
};

const iconNames = {
  instagram: 'instagram-custom-fg',
  youtube: 'youtube-custom-fg',
  tiktok: 'tiktok-custom-fg'
};

const ConsentPlaceholder = (
  {
    type,
    link,
    withLinkOnTheLeft,
    withLearnMore,
    onClick
  }: Props
): JSX.Element => {
  const linkClasses = classnames('consent-placeholder__link', {
    'consent-placeholder__link--left-aligned': withLinkOnTheLeft
  });

  return (
    <div
      className="consent-placeholder"
    >
      <Popover
        classNameTrigger="consent-placeholder__full-size-wrapper"
        classNameWrapper="consent-placeholder__full-size-wrapper"
        triggerComponent={(
          <div
            className="consent-placeholder__inner"
            onClick={onClick}
          >
            <SVGDynamicIcon
              customColor="grey"
              name={iconNames[type]}
              width={24}
              height={24}
            />
            {withLearnMore && (
              <div className="consent-placeholder__learn-more">
                {__t('content_placeholder.learn_more')}
              </div>
            )}
          </div>
        )}
      >
        <ContentPlaceholderInfo />
      </Popover>

      {Boolean(link) && (
        <a
          href={link}
          target="_blank"
          rel="noopener noreferrer"
          className={linkClasses}
          onClick={(event) => {
            event.stopPropagation();
          }}
        >
          <Tooltip message={__t(`content_placeholder.view_content.${type}`)}>
            <SVGDynamicIcon
              customColor="grey"
              name="link-external-custom-fg"
              width={16}
              height={16}
            />
          </Tooltip>
        </a>
      )}
    </div>
  );
};

export default ConsentPlaceholder;
